// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"table-container-86b","table":"table-565"};